import isEqual from 'react-fast-compare';
import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { ContentId } from 'src/utils/constants/contentId';
import { COLLECTION_FILTER_OP_TO_CID } from 'src/utils/constants/contentIdMaps';
import { DeliveryType, FilterOperationType } from 'src/WebApiController';

import { DeliveryTypeMultiSelector } from '../../Selectors/DeliveryTypeSelector';

export type DeliveryTypeMultiFilter = {
  deliveryTypes?: DeliveryType[] | null;
  operations?: {
    deliveryTypeOp?: FilterOperationType | null;
  } | null;
};

export const useDeliveryTypeMultiFilters = <
  TFilter extends DeliveryTypeMultiFilter,
>({
  query,
  setQuery,
  supportMultiOperation = false,
  isHorizontalLayout = false,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
  supportMultiOperation?: boolean;
  isHorizontalLayout?: boolean;
}): FilterToolbarItem => {
  return {
    filterId: 'deliveryTypes' as FilterToolbarItemId,
    labelContentId: ContentId.Delivery,
    filterQueryKeys: ['deliveryTypes'] as FilterToolbarItemId[],
    filterItem: (
      <DeliveryTypeMultiSelector
        style={{ width: '100%' }}
        values={query.deliveryTypes ?? []}
        operation={query.operations?.deliveryTypeOp ?? null}
        operationOptionsContent={
          supportMultiOperation ? COLLECTION_FILTER_OP_TO_CID : undefined
        }
        isHorizontalLayout={isHorizontalLayout}
        enableEmptySelection
        onChange={({ newValues: deliveryTypes, operation }) => {
          if (
            !isEqual(deliveryTypes, query.deliveryTypes) ||
            operation !== query.operations?.deliveryTypeOp
          ) {
            setQuery({
              ...query,
              deliveryTypes: deliveryTypes?.length ? deliveryTypes : null,
              operations: supportMultiOperation
                ? {
                    ...query.operations,
                    deliveryTypeOp: operation ?? null,
                  }
                : null,
            });
          }
        }}
      />
    ),
  };
};
